module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAAGCAYAAAC7BHJ5AAAAAXNSR0IArs4c6QAAADBJREFUOBFjZDhw8D/DKKAoBJgo0j2qGRwCo4FIhYQwGoijgUiFEKCCEaMpkQqBCAA5sAKMzQr+rwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/line.png
// module id = 632
// module chunks = 58